import {text, border, background, icon} from './tokens/semantic/colors'

const themeColors = {
    colors: {
        color: {
            text,
            border,
            background,
            icon,
        },
    },
}

export default themeColors
